import { useEffect } from "react";

import { IgStorage } from "@src/utils/igStorage";

import { useMutateChargeId } from "../api/organizations/mutate-charge-id";
import { useUser } from "../api/user-auths/login";
import { message } from "../utils/message";

export const useAuth = () => {
  const mutateChargeId = useMutateChargeId();
  const user = useUser();

  useEffect(() => {
    if (user.isSuccess) {
      if (user.data.type === "redirect") {
        window.location.href = user.data.redirect;
      } else if (user.data.type === "clear") {
        IgStorage.clearAuthTokens();
        window.location.reload();
      } else if (user.data.token) {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const charge_id = params.get("charge_id") || undefined;
        const code = params.get("code") || undefined;
        if (charge_id !== undefined) {
          mutateChargeId.mutate({ chargeId: charge_id, code });
        }
      }
    } else if (user.fetchStatus === "idle") {
      // This fixes the forever loading issue
      message({ type: "NOT_LOGGED_IN", payload: "user.isIdle" });
    }
  }, [user.isLoading, user.data, user.isSuccess]);

  return user;
};
